/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader/root'

// hinzugefügte Pakete
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Waypoint } from 'react-waypoint'
import Chart from '../../components/chart'
import Scrollchor from 'react-scrollchor'
import WhenInView from '../../components/WhenInView'
import DeviceSwitch from '../../components/DeviceSwitch'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// CSS
import 'styles/App.css'
import './style.scss'

const ARTICLE_ID = '24716954'

class AppComponent extends React.Component<Props> {
  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />
        <header
          className='ui vertical very fitted segment'
          style={{ paddingBottom: 0 }}
        >
          <div className='ui container'>
            <h1 className='ui header title' style={{ marginTop: '15px' }}>
              Ade Schnee
            </h1>
            <div className='ui medium header' style={{ marginTop: '0px' }}>
              <h2 className='ui header' style={{ marginTop: 0 }}>
                <div className='sub header'>
                  Wo ist es noch schneesicher? Wie viele Schneetage 33 Schweizer
                  Orte in den letzten 30 Jahren verloren haben.
                </div>
              </h2>
            </div>
            <p className='lead text contains hidden link'>
              <strong>
                Patrick Vögeli und Marc Brupbacher, Interaktiv-Team
              </strong>
            </p>
            <p>
              <em>
                Dieser Beitrag wurde erstmals im Dezember 2018 publiziert. Wir
                haben für diese 2019er-Version alle Daten aktualisiert.
              </em>
            </p>
          </div>
        </header>

        <DeviceSwitch />

        {/* Einleitung */}
        <div
          className='ui vertical fitted segment background'
          style={{ paddingTop: '0em' }}
        >
          <div className='ui text container'>
            <p>
              Schnee ist wichtig für Tourismus und Wasserwirtschaft, er weckt
              aber auch Emotionen. Die Schweiz immer häufiger ohne Schnee?
              Unvorstellbar. Aber, wohl schon schneller Realität, als uns lieb
              ist. Lange Messreihen zeigen, dass es in den vergangenen 30 Jahren
              im Winter in der Schweiz je nach Ort und Lage bis zu 67 Prozent
              weniger Schneetage pro Saison gab als noch von 1960 bis 1989 (Was
              gilt als Schneetag?&nbsp;
              <Scrollchor to='#methodik' style={{ whiteSpace: 'nowrap' }}>
                <i className='icon small angle double down' />
                Siehe Methodik
              </Scrollchor>
              ). «Diese Entwicklung ist bedenklich», sagt Klimaforscher
              Christoph Marty vom Institut für Schnee- und Lawinenforschung
              (SLF), von welchem auch die Daten stammen. «Historische
              Aufzeichnungen der letzten 500 Jahre zeigen, dass es im Schweizer
              Mittelland noch nie eine so geringe Schneebedeckung gegeben hat
              wie in den letzten Dekaden», so Marty weiter.
            </p>
            <p>
              Um diesen vor allem in tiefen und mittleren Lagen dramatischen
              Wandel besonders sichtbar zu machen, haben wir die Entwicklung der
              Schneedecke an 33 Orten der ganzen Schweiz visualisiert. Dabei
              vergleichen wir die Mittelwerte der Anzahl Schneetage der Perioden
              1960 bis 1989 und 1990 bis 2019.
            </p>
            <p>
              In Zürich lag beispielsweise von 1960 bis 1989 durchschnittlich an
              34 Tagen Schnee, von 1990 bis 2019 waren es nur noch 19 Tage, also
              44 Prozent weniger. «Wenn sich die Erde gleich erwärmt wie die
              letzten Jahrzehnte, wird ab 2050 in Zürich vielleicht noch alle 15
              Jahre mehr als eine Woche Schnee liegen», sagt Marty.
            </p>
          </div>
        </div>

        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category first'>
            <div className='content-wrapper'>
              <div className='category content tief'>
                <span className='category title tief'>Tiefe Lagen</span>
                <span className='category hoehe tief'>201–800 m</span>
              </div>

              <div className='animation-container'>
                <WhenInView>
                  <iframe
                    src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-tiefe-lagen/snowfall_kugel-tiefe-lagen.html'
                    frameBorder='0'
                    allowtransparency='true'
                    allowFullScreen='allowfullscreen'
                    webkitallowfullscreen='webkitallowfullscreen'
                    mozallowfullscreen='mozallowfullscreen'
                    oallowfullscreen='oallowfullscreen'
                    msallowfullscreen='msallowfullscreen'
                    width='100%'
                    scrolling='no'
                  />
                </WhenInView>
              </div>

              <div className='list tief'>
                <ul>
                  <li>
                    Als Schneetag gilt ein Tag mit{' '}
                    <span style={{ fontSize: '1em', fontWeight: 'bold' }}>
                      mind. 5 cm Schnee
                    </span>
                  </li>
                  <li>
                    Wir vergleichen die Ø Anzahl Schneetage pro Saison der
                    Perioden 1960–1989 und 1990–2019
                  </li>
                  <li>Eine Wintersaison dauert von November bis April</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className='ui container'>
          <div className='ui grid charts'>
            <div className='ui centered column row'>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Lugano'
                  location='Lugano'
                  meter='273 m'
                  percentage='–67'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Sion'
                  location='Sion'
                  meter='480 m'
                  percentage='–54'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Locarno-Monti'
                  location='Locarno-Monti'
                  meter='365 m'
                  percentage='–53'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Visp'
                  location='Visp'
                  meter='655 m'
                  percentage='–51'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Basel'
                  location='Basel'
                  meter='316 m'
                  percentage='–50'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Neuenburg'
                  location='Neuenburg'
                  meter='485 m'
                  percentage='–50'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Brusio'
                  location='Brusio'
                  meter='800 m'
                  percentage='–45'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Zürich'
                  location='Zürich'
                  meter='556 m'
                  percentage='–44'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Bellinzona'
                  location='Bellinzona'
                  meter='230 m'
                  percentage='–36'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Bern'
                  location='Bern'
                  meter='555 m'
                  percentage='–32'
                  percentageText='Schneetage'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='ui text container' style={{ position: 'relative' }}>
          <h4>
            Was ist Ende der 1980er-Jahre passiert, warum hat die Schneedecke so
            sprunghaft abgenommen?
          </h4>
          <p>
            Ende der 1980er-Jahre sind die Temperaturen abrupt gestiegen. Dies
            ist ein globales Phänomen, das man noch nicht im Detail verstanden
            hat. Seither ist auch eine noch nie beobachtete Abnahme der
            Schneetage festzustellen. In tiefen Lagen ist es so warm geworden,
            dass der Niederschlag markant häufiger als Regen und nicht mehr als
            Schnee fällt. Eine Rolle für diesen plötzlichen Temperaturanstieg
            dürfte die Luftverschmutzungsbekämpfung in den 1980er-Jahren
            gespielt haben, die dann spätestens in den 1990er-Jahren zum
            sogenannten Global Brightening führte. Die Luft wurde sauberer,
            somit konnten die Sonnenstrahlen die Erde wieder stärker aufheizen
            und der vom Menschen gemachte Treibhauseffekt voll durchschlagen.
            Weil man diese Zusammenhänge aber bis heute nicht richtig
            quantifizieren kann und sicher auch noch Meeresströmungen eine Rolle
            spielen, können sich sprunghafte Temperaturanstiege erneut ereignen.
          </p>

          <h4>
            Wie sieht ein typischer Winter in der Schweiz im Flachland in 30
            Jahren aus?
          </h4>
          <p>
            Wenn die Temperaturen gleich steigen wie zuletzt, dann muss in
            Zürich, Basel und Bern mit 80 Prozent weniger Schneetagen bis 2050
            gerechnet werden. Es bleiben also nur noch ein paar wenige Tage mit
            Schnee pro Saison, und es wird eine zunehmende Anzahl Winter
            gänzlich ohne Schneedecke geben. Das zeigen Modellrechnungen des
            SLF. Auch die mittleren Lagen verlieren bis in 30 Jahren 80 Prozent
            der Schneetage. Dort wird die Schneedecke ebenfalls häufig nicht
            mehr permanent sein. Langfristig betrachtet hat der
            Winterniederschlag zwar leicht zugenommen, aber immer häufiger als
            Regen und nicht mehr als Schnee.
          </p>
        </div>

        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category'>
            <div className='content-wrapper'>
              <div className='category content mittlere'>
                <span className='category title mittlere'>Mittlere Lagen</span>
                <span className='category hoehe mittlere'>801–1300 m</span>
              </div>
              <div className='animation-container'>
                <WhenInView>
                  <iframe
                    src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-mittlere-lagen/snowfall_kugel-mittlere-lagen.html'
                    frameBorder='0'
                    allowtransparency='true'
                    allowFullScreen='allowfullscreen'
                    webkitallowfullscreen='webkitallowfullscreen'
                    mozallowfullscreen='mozallowfullscreen'
                    oallowfullscreen='oallowfullscreen'
                    msallowfullscreen='msallowfullscreen'
                    width='100%'
                    scrolling='no'
                  />
                </WhenInView>
              </div>
              <div className='list mittlere'>
                <ul>
                  <li>
                    Als Schneetag gilt ein Tag mit{' '}
                    <span style={{ fontSize: '1em', fontWeight: 'bold' }}>
                      mind. 30 cm Schnee
                    </span>
                  </li>
                  <li>
                    Wir vergleichen die Ø Anzahl Schneetage pro Saison der
                    Perioden 1960–1989 und 1990–2019
                  </li>
                  <li>Eine Wintersaison dauert von November bis April</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className='ui container'>
          <div className='ui grid charts'>
            <div className='ui centered column row'>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Poschiavo'
                  // className='mobile hidden'
                  location='Poschiavo'
                  meter='1078 m'
                  percentage='–63'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Lauterbrunnen'
                  location='Lauterbrunnen'
                  meter='805 m'
                  percentage='–59'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Einsiedeln'
                  location='Einsiedeln'
                  meter='910 m'
                  percentage='–51'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='La Chaux de Fonds'
                  location='Chaux-de-Fonds'
                  meter='1018 m'
                  percentage='–49'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Küblis'
                  location='Küblis'
                  meter='810 m'
                  percentage='–45'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Engelberg'
                  location='Engelberg'
                  meter='1060 m'
                  percentage='–37'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Scuol'
                  location='Scuol'
                  meter='1298 m'
                  percentage='–29'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Airolo'
                  location='Airolo'
                  meter='1139 m'
                  percentage='–25'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Campo Blenio'
                  location='Campo Blenio'
                  meter='1215 m'
                  percentage='–17'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Klosters'
                  location='Klosters'
                  meter='1195 m'
                  percentage='–16'
                  percentageText='Schneetage'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='ui text container' style={{ position: 'relative' }}>
          <h4>Warum hat Klosters relativ wenig Schnee verloren?</h4>
          <p>
            Klosters ist eine der höchsten und schneereichsten Stationen in
            dieser Höhenlage, es gibt dort besonders viel Niederschlag. Das
            Prättigau ist ähnlich ausgerichtet wie das Toggenburg und das
            Glarnerland, gegen Nordwesten offen, da staut sich die Feuchtigkeit.
            Und trotzdem gilt Braunwald GL nicht als schneesicher, obwohl der
            Ort einer der höchsten Neuschneesummen der Schweiz aufweisen kann.
            Der Grund: Braunwald ist gleichzeitig eine Sonnenterrasse, und der
            Glarner Föhn tut das seinige dazu. Es gibt sehr viele lokale
            Phänomene, die die Schneedecke beeinflussen. Darum haben sicher auch
            Standortverschiebungen der Messstationen innerhalb der untersuchten
            60 Jahre einen Einfluss auf die Daten.
          </p>

          <h4>Schneesicher scheint auch Andermatt. Warum?</h4>
          <p>
            Andermatt profitiert aufgrund seiner Lage am Alpenhauptkamm
            zweifach. Erstens erhält es häufig Schnee bei Nord- und Südlagen,
            und zweitens ist der Talboden von einem Kältesee beeinflusst, der
            die Schneedecke vor warmen Temperaturen schützt. Dafür ist Andermatt
            eher schattig und windig.
          </p>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />

          <h4>Warum gibt es im Engadin so wenig Schnee?</h4>
          <p>
            Das Engadin liegt zwar auch am für Niederschlag günstig gelegenen
            Alpenhauptkamm, aber die umschliessenden Berge sind dort so hoch und
            zahlreich, dass die Wolken häufig nicht mehr durchkommen. Ein
            typisches inner-alpines Trockental. Auch Zermatt ist so ein
            Trockental, gegen Westen geschlossen, da sind die Berge sogar
            besonders hoch. Es braucht dort schon ganz spezielle Wetterlagen,
            dass es viel Schnee gibt. Dafür ist Zermatt sehr sonnig.
          </p>

          <h4>
            In Airolo gibt es relativ viele Schneetage, und der Rückgang ist
            moderat, obwohl es im Süden liegt. Warum?
          </h4>
          <p>
            Airolo und Campo Blenio profitieren beide von ihren Standorten am
            Ende eines engen Tales, wo erstens häufig Niederschlag fällt und die
            Nullgradgrenze aufgrund von Staueffekten häufig tiefer ist als
            anderswo.
          </p>
        </div>

        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category'>
            <div className='content-wrapper'>
              <div className='category content hohe'>
                <span className='category title hohe'>Hohe Lagen</span>
                <span className='category hoehe hohe'>1301–1800 m</span>
              </div>

              <div className='animation-container'>
                <WhenInView>
                  <iframe
                    src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-hohe-lagen/snowfall_kugel-hohe-lagen.html'
                    frameBorder='0'
                    allowtransparency='true'
                    allowFullScreen='allowfullscreen'
                    webkitallowfullscreen='webkitallowfullscreen'
                    mozallowfullscreen='mozallowfullscreen'
                    oallowfullscreen='oallowfullscreen'
                    msallowfullscreen='msallowfullscreen'
                    width='100%'
                    scrolling='no'
                  />
                </WhenInView>
              </div>

              <div className='list hohe'>
                <ul>
                  <li>
                    Als Schneetag gilt ein Tag mit{' '}
                    <span style={{ fontSize: '1em', fontWeight: 'bold' }}>
                      mind. 50 cm Schnee
                    </span>
                  </li>
                  <li>
                    Wir vergleichen die Ø Anzahl Schneetage pro Saison der
                    Perioden 1960–1989 und 1990–2019
                  </li>
                  <li>Eine Wintersaison dauert von November bis April</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className='ui container'>
          <div className='ui grid schnee charts'>
            <div className='eight centered column row'>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Zermatt'
                  location='Zermatt'
                  meter='1600 m'
                  percentage='–38'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Cavaglia'
                  location='Cavaglia'
                  meter='1690 m'
                  percentage='–34'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Zuoz'
                  location='Zuoz'
                  meter='1710 m'
                  percentage='–33'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Grindelwald'
                  location='Grindelwald Bort'
                  meter='1560 m'
                  percentage='–31'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Davos'
                  location='Davos'
                  meter='1560 m'
                  percentage='–29'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Samedan'
                  location='Samedan'
                  meter='1705 m'
                  percentage='–24'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Ritom'
                  location='Ritom'
                  meter='1800 m'
                  percentage='–23'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Bosco Gurin'
                  location='Bosco Gurin'
                  meter='1530 m'
                  percentage='–22'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Ulrichen'
                  location='Ulrichen'
                  meter='1350 m'
                  percentage='–22'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='St. Antönien'
                  location='St. Antönien'
                  meter='1510 m'
                  percentage='–21'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Andermatt'
                  location='Andermatt'
                  meter='1440 m'
                  percentage='–19'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Mürren'
                  location='Mürren'
                  meter='1650 m'
                  percentage='–12'
                  percentageText='Schneetage'
                />
              </div>
              <div className='eight wide mobile five wide tablet four wide computer column'>
                <Chart
                  title='Trübsee'
                  location='Trübsee'
                  meter='1770 m'
                  percentage='–4'
                  percentageText='Schneetage'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='ui text container' style={{ position: 'relative' }}>
          <h4>
            In den vergangenen beiden Wintern gab es so viel Schnee wie lange
            nicht mehr. Wie geht das zusammen?
          </h4>
          <p>
            Der Winter 2017/18 war in den Alpen einer der schneereichsten der
            letzten 30 Jahre, aber nur oberhalb von 1500 Meter. Weiter unten war
            es häufig viel zu warm für Schneefall. Der Dezember und Januar waren
            sehr niederschlagsreich, was in grosser Höhe zu sehr viel Schnee in
            kurzer Zeit und entsprechender Lawinengefahr führte. Gleichzeitig
            kam es weiter unten zu Murgängen, Hangrutschungen und Hochwasser
            mitten im Winter. In diesem Sinne war der letzte Winter in der Tat
            aussergewöhnlich. Aber auch wieder nicht: Klimamodelle sagen
            vermehrt Überschwemmungen im Winter voraus.
          </p>

          <h4>
            Wenn es durch den Klimawandel mehr Niederschlag gibt, fällt dann in
            hohen Lagen mehr Schnee?
          </h4>
          <p>
            Richtig. Modellrechnungen zeigen, dass dieser Effekt oberhalb von
            2500 Metern bis maximal Mitte Jahrhundert zu grösseren
            Winter-Schneehöhen führen kann. Die gleichen Modelle zeigen aber
            auch, dass dieses Mehr an Schnee nicht in den Sommer gerettet werden
            kann, weil die grosse Wärme eine intensivere Schmelze verursacht.
            Ein gutes Beispiel dafür ist der letzte Winter, die
            überdurchschnittlichen Schneemengen waren überraschend schnell
            wieder weg, den Gletschern hat das nicht geholfen. Ab 2050 ist dann
            aber auch in hohen Lagen immer öfter Schluss mit viel Schnee. Wie
            die neuesten Klimaszenarien für die Schweiz zeigen, wird die
            winterliche Nullgradgrenze bis Mitte Jahrhundert im Bereich der
            hohen Lagen liegen (1301 bis 1800 Meter), Naturschnee allein kann
            dann auch dort keine Schneesicherheit mehr garantieren.
          </p>

          <h4>
            Davos liegt über 1500 Meter, weist aber relativ wenig Schneetage aus
            und hat auch viel verloren in den letzten 30 Jahren. Warum?
          </h4>
          <p>
            Davos liegt an der Grenze zwischen Nord- und Mittelbünden und erhält
            darum bereits nicht mehr so viel Niederschlag wie Klosters oder
            Arosa.
          </p>

          <h4>
            In Trübsee ist die Schneedecke über 60 Jahre praktisch konstant
            geblieben. Gibt es eine Erklärung?
          </h4>
          <p>
            Trübsee ist die schneereichste und eine der höchsten Stationen in
            diesem Datensatz und zudem auch in einem lokalen Kältesee gelegen.
            Auf dieser Höhenlage ist es trotz Erwärmung häufig noch kalt genug,
            sodass der Niederschlag weiterhin meistens als Schnee fällt. Andere
            ähnlich hoch gelegene Stationen am Alpennordhang zeigen einen
            vergleichbar kleinen Rückgang der Schneetage.
          </p>

          <h4>
            Was müssten wir tun, damit wir auch in 50 Jahren garantiert viel
            Schnee auf den Pisten haben?
          </h4>
          <p>
            Das Klimasystem ist so träge, dass die Temperaturen die nächsten
            Jahrzehnte auf jeden Fall weiter zunehmen und die Schneetage
            entsprechend abnehmen werden. Wir können nur Schadensbegrenzung
            betreiben, damit es nicht noch schlimmer wird. Wenn wir es schaffen,
            die Erwärmung bei maximal 2°C zu begrenzen, wird der Rückgang der
            Schneedecke bis Ende Jahrhundert nur halb so gross sein, wie wenn
            wir einfach wie bisher weitermachen.
          </p>
        </div>

        {/* footer */}

        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Funktionierte die technische Umsetzung?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Konzept, Programmierung und Grafiken',
              'Patrick Vögeli und Marc Brupbacher'
            ]
          ]}
          starColor='blue'
          publicationDate={1500986249}
        >
          <div className='ui vertical grey segment' id='methodik'>
            <div
              className='ui text container methodik'
              style={{ position: 'relative' }}
            >
              <div className='innerWrapperMethodik'>
                <h3>Methodik</h3>

                <h4>Expertise</h4>
                <p>
                  Dr. Christoph Marty, WSL-Institut für Schnee- und
                  Lawinenforschung SLF.
                </p>

                <h4>Quelle und Analyse</h4>
                <p>
                  Die täglichen Schneehöhenangaben stammen vom Institut für
                  Schnee- und Lawinenforschung (SLF) sowie vom Bundesamt für
                  Meteorologie und Klimatologie (Meteo Schweiz). Für die Auswahl
                  wurden lediglich Stationen berücksichtigt, die über
                  Langzeitdaten von mehr als 60 Jahren verfügen. Die 33
                  Stationen befinden sich in der ganzen Schweiz und sind in drei
                  Höhenzonen unterteilt: Tiefe Lagen 201–800 m, mittlere Lagen
                  801–1300 m und hohe Lagen 1301–1800 m. Fehlende oder
                  fehlerhafte Werte wurden mithilfe von Daten von benachbarten
                  Messstationen ergänzt.
                </p>
                <p>
                  Weil die jährliche Schneedecke grossen natürlichen
                  Schwankungen unterliegt, haben wir die 60 Jahre in zwei gleich
                  grosse Zeitperioden (1960–1989 und 1990–2019) unterteilt, um
                  so mit den jeweiligen Mittelwerten den Unterschied von gestern
                  zu heute aufzuzeigen. Als Wintersaison wurde November bis
                  April gewählt, weil damit die Anzahl Tage mit nennenswerter
                  Schneebedeckung (Schneetage) an den höher gelegenen Stationen
                  besser erfasst werden kann.
                </p>
                <p>
                  Als Schneetag zählt ein Tag mit einer bestimmten
                  Mindestschneehöhe. Die Grenzwerte wurden anhand von typischen
                  Winteraktivitäten in der jeweiligen Höhenzone gewählt: In
                  tiefen Lagen ist es der Bau eines Schneemanns (5 Zentimeter
                  Schnee), in mittleren Lagen Langlaufen (30 cm) und in hohen
                  Lagen Skifahren (50 cm). Aufgrund der unterschiedlichen
                  Grenzwerte können die drei Höhenlagen nicht direkt
                  untereinander verglichen werden.
                </p>
                <p style={{ marginBottom: '0em' }}>
                  Die Anzahl Schneetage eignet sich als Indikator, weil er
                  Niederschlag, Temperatur und Zeit vereint und zudem für
                  jedermann gut vorstellbar ist. Im Gegensatz dazu ist der
                  Indikator der durchschnittlichen Schneehöhe eine Zahl, die von
                  Extremwerten beeinflusst wird und schlecht fassbar ist. Der
                  Indikator Neuschneesumme sagt nur etwas über die
                  Schneefallmenge aus, ohne zu berücksichtigen, an wie vielen
                  Tag Schnee gefallen ist und ob der Schnee liegen geblieben
                  ist. Die maximale Schneehöhe wiederum ist zwar wichtig für
                  gewisse Anwendungen, ist aber häufig nur von kurzfristiger
                  Dauer und sagt gerade in tiefen Lagen nichts über den
                  Schneereichtum eines Winters aus.
                </p>
              </div>
            </div>
          </div>
        </Footer>
      </div>
    )
  }
}

export default hot(AppComponent)
